<template>
  <div>
    <file-uploader :compMode="compMode" entite="Investment"></file-uploader>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-briefcase"></i> 
        <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('project.investment.create.title') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('project.investment.edit.title') }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{ $t('project.investment.view.title') }}</span>
      </div>
      <div class="card-body">

        <errorMessage v-bind:message="error"></errorMessage>

        <form @keyup.enter="createEntity">

          <create-investment ref="createInvestment" :investment="entity" :compMode="compMode">
            <div slot="project">

              <div class="row">
                <div class="form-group col-md-2">
                  <label for="unitSurfaceInput">{{ $t('project.investment.form.property.unitSurface') }}*</label>
                  <input maxlength="100" :data-vv-as="$t('project.investment.form.property.unitSurface')" v-model.trim="entity.unitSurface" v-validate="'required'" name="unitSurface" type="text" 
                  class="form-control" id="unitSurfaceInput" placeholder="Nom"  /> 
                  <span class="text-danger" v-if="errors.has('unitSurface')">{{ errors.first('unitSurface') }}</span>
                </div>

                <div class="form-group col-md-10">
                    <label for="nameInput">{{ $t('project.investment.form.name') }}</label>
                    <input v-model.trim="entity.name" name="name" type="text" class="form-control" id="nameInput"  />
                    <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12">
                    <div class="form-group">
                        <label for="detailInput">{{ $t('project.investment.form.property.detail') }}</label>
                        <textarea v-model.trim="entity.detail" name="detail" type="text" rows=5 class="form-control" id="detailInput" 
                            :placeholder="$t('project.investment.form.property.detail')" ></textarea>
                        <span class="text-danger" v-if="errors.has('detail')">{{ errors.first('detail') }}</span>
                    </div>
                </div>
              </div>

              
          </div>

          </create-investment>

          <div class="card font-weight-bold text-uppercase bg-warning mb-3" v-if="entity.imported && compMode == CRUDMODE.UPDATE">
            <div class="card-body">
              <label class="custom-control custom-checkbox" >
                  <input type="checkbox" name="lead"
                    value="1" class="custom-control-input" id="removeImportedFlag" v-model="entity.removeImportedFlag" >
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-label">{{ $t('removeImportedFlag') }}</span>
              </label>
            </div>
          </div>

          <a @click="createEntity" v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" id="addButton" class="btn btn-primary">
            {{ $t('form.create_button') }}
          </a>

          <a @click="editEntity" v-if="compMode == CRUDMODE.UPDATE" id="editButton" class="btn btn-primary">
            {{ $t('form.edit_button') }}
          </a>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  InvestmentServiceClient,
  PropertyInvestmentServiceClient,
  PropertyServiceClient,
  PropertyInvestmentDto,
  ProjectDto,
  EntrepriseDto,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'

import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Enum from '../../shared/enum'

import CreateInvestment from './CreateInvestment'

export default {
  name: 'CreatePropertyInvestment',
  mixins: [CrudMixin],
  data() {
    let dto = new PropertyInvestmentDto()
    dto.init({investmentType: 2})
    dto.project = new ProjectDto()
    dto.project.entreprise = new EntrepriseDto()
    dto.investmentValues = []
    dto.investmentProcessus = []

    return {
      user: {},
      ready: false,
      entity: dto,
    }
  },
  methods: {
    userSelected: function(user) {
      let localUser = user
      localUser.creationTime = moment(localUser.creationTime._i)

      this.user = UserDto.fromJS(localUser)
    },
    manageEntity: function() {
      debugger
      let cleanEntity = this.cleanFields(this.entity)

      if (this.compMode == Enum.Mode.CREATE) {
        cleanEntity.project = null
        cleanEntity.user = null
      } else {
        cleanEntity.project = ProjectDto.fromJS(cleanEntity.project)

        if (cleanEntity.user != null && this.user.firstName !== undefined) {
          cleanEntity.user = this.user
        }
      }

      if (cleanEntity.investmentValues != null) {
        for (var ix = 0; ix < cleanEntity.investmentValues.length; ix++) {
          if (cleanEntity.investmentValues[ix].type == 2 && cleanEntity.investmentValues[ix].member != undefined) {
            cleanEntity.investmentValues[ix].memberId = cleanEntity.investmentValues[ix].member.id
            cleanEntity.investmentValues[ix].partnerId = null
          } else if (cleanEntity.investmentValues[ix].type == 1 && cleanEntity.investmentValues[ix].partner != undefined) {
            cleanEntity.investmentValues[ix].partnerId = cleanEntity.investmentValues[ix].partner.id
            cleanEntity.investmentValues[ix].memberId = null
          }
          cleanEntity.investmentValues[ix].member = null
          cleanEntity.investmentValues[ix].partner = null
        }
      }

      return cleanEntity
    },
    createEntity: function() {
      let self = this
      this.$validator
        .validateAll()
        .then(result => {
          if (result && self.ready) {
            let entityService = ServiceFactory.create(PropertyInvestmentServiceClient)

            entityService
              .create(self.manageEntity())
              .then(res => this.persistFiles(res.id))
              .then(res => {
                this.$swal('Succès', this.$t('project.investment.create.succes'), 'success')
                this.$router.push({path: '/projects/investments'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log('error: ' + self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editEntity: function() {
      let self = this
      this.$validator
        .validateAll()
        .then(result => {
          if (result && this.ready) {
            let entityService = ServiceFactory.create(PropertyInvestmentServiceClient)

            entityService
              .update(self.manageEntity())
              .then(res => this.persistFiles(res.id))
              .then(res => {
                self.$swal('Succès', this.$t('project.investment.edit.succes'), 'success')
                self.$router.push({path: '/projects/investments'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    sortValues: function(list) {
      return _.sortBy(list, function(x) {
        return [x.partner, x.member, x.partner != null ? x.partner.name : '', x.member != null ? x.member.familyName : '']
      })
    },
    fetchData: function() {
      let service = ServiceFactory.create(InvestmentServiceClient)
      let EntityService = ServiceFactory.create(PropertyInvestmentServiceClient)

      let self = this
      let promisseAll

      if (this.compMode != Enum.Mode.CREATE) {
        let getEntity = EntityService.get(this.$route.params.id)
        getEntity
          .then(res => {
            self.entity = res

            if (self.entity.investmentValues == null) {
              self.entity.investmentValues = []
            } else {
              self.entity.investmentValues = this.sortValues(self.entity.investmentValues)
            }

            if (self.entity.investmentProcessus == null) {
              self.entity.investmentProcessus = []
            }

            self.checkCopyMode(self.entity)
          })
          .catch(err => {
            console.log(err)
          })

        promisseAll = Promise.all([getEntity])
      } else {
        promisseAll = Promise.all([])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
  },
  components: {
    errorMessage: ErrorMessage,
    CreateInvestment,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn-primary {
  color: #fff !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Investment/CreatePropertyInvestment.vue